/**
 * @generated SignedSource<<845115e4c61413e9cb43bd552b7b15f8>>
 * @relayHash 933c34da773ff5425c850d14b8f26c28
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 933c34da773ff5425c850d14b8f26c28

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SendOtpCodeResponse",
    "kind": "LinkedField",
    "name": "sendOtpCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "codeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SendOtpCodeMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SendOtpCodeMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "933c34da773ff5425c850d14b8f26c28",
    "metadata": {},
    "name": "SendOtpCodeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "4fa75b6cf9879842ed94540a01eee597";

export default node;
